import styled from 'styled-components';
import {baseColors} from '../../../../../../../../themes/definitions/mrgreen/base-colors';
import {CellValueTextDefaultBox} from './cell-value-text.default.box';

export const CellValueTextMrGreenBox = styled(CellValueTextDefaultBox)`
    color: ${baseColors.white};
`;